const API_URL = "https://bspics.top/APIv2/";

async function apiRequest(path, options = {}) {
    const response = await fetch(`${API_URL}${path}`, {
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            ...(options.headers || {}),
        },
        ...options,
    });

    let data = null;
    try {
        data = await response.json();
    } catch (error) {
        data = null;
    }

    if (!response.ok) {
        const message = data?.error || "Request failed";
        const apiError = new Error(message);
        apiError.status = response.status;
        apiError.data = data;
        throw apiError;
    }

    return data;
}

export {API_URL, apiRequest};
